import React from "react";
import { useState, useEffect, useMemo } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    getDistrictList,
    getBlockList,
    getGpList,
} from "../../Service/TotalAvailableFund";
import {
    getSchemeMaster,
    getFinYear,
    getPriWiseReceiptPayment,
} from "../../Service/SchemeBalanceService";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const PriReceiptPayment = () => {
    const getCurrentDate = () => new Date().toISOString().split("T")[0];

    const jsonString = sessionStorage.getItem("SAHAJ_SARAL_USER");
    const userData = JSON.parse(jsonString);

    const [schemeBalanceDetails, setSchemeBalanceDetails] = useState([]);
    const [district, setDistrict] = useState("");
    const [block, setBlock] = useState("");
    const [gp, setGp] = useState("");
    const [getDistrictDataList, setDistrictDataList] = useState([]);
    const [getBlockDataList, setBlockDataList] = useState([]);
    const [getGpDataList, setGpDataList] = useState([]);
    const [reportFor, setReportFor] = useState("");
    const [schemeMaster, setSchemeMaster] = useState([]);
    const [scheme, setScheme] = useState("");

    const [finYearList, setFinYearList] = useState([]);
    const [finYear, setFinYear] = useState("");

    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState(getCurrentDate());

    useEffect(() => {
        getDistrictList()
            .then(function (result) {
                const response = result?.data;
                setDistrictDataList(response || []);
            })
            .catch((error) => {
                console.error("Error fetching district list:", error);
                setDistrictDataList([]);
            });

        // getSchemeMaster()
        //     .then(function (result) {
        //         const response = result?.data;
        //         setSchemeMaster(response || []);
        //     })
        //     .catch((error) => {
        //         console.error("Error fetching scheme master:", error);
        //         setSchemeMaster([]);
        //     });
    }, []);

    const selectedLgdCode = useMemo(() => {
        return gp || block || district || "";
    }, [district, block, gp]);

    useEffect(() => {
        if (!selectedLgdCode) {
            setFinYearList([]);
            setFinYear("");
            return;
        }

        getFinYear(selectedLgdCode)
            .then((result) => {
                const response = result?.data;
                setFinYearList(response?.finYears || []);
                setFinYear(response?.finYears?.[0]?.finYear || "");
            })
            .catch((error) => {
                console.error("Error fetching financial year:", error);
                setFinYearList([]);
                setFinYear("");
            });
    }, [selectedLgdCode]);

    const onDistrict = (e) => {
        const value = e.target.value;
        setDistrict(value);
        setBlock("");
        setGp("");
        setReportFor("");
        setSchemeBalanceDetails([]);
        setBlockDataList([]);
        setGpDataList([]);
        setFinYear("");
        setFinYearList([]);

        if (value) {
            getBlockList(value)
                .then(function (result) {
                    const response = result?.data;
                    setBlockDataList(response || []);
                })
                .catch((error) => {
                    console.error("Error fetching block list:", error);
                    setBlockDataList([]);
                });
        }
    };

    const onBlock = (e) => {
        const value = e.target.value;
        setBlock(value);
        setGp("");
        setReportFor("");
        setSchemeBalanceDetails([]);
        setGpDataList([]);
        setFinYear("");
        setFinYearList([]);

        if (value) {
            getGpList(value)
                .then(function (result) {
                    const response = result?.data;
                    setGpDataList(response || []);
                })
                .catch((error) => {
                    console.error("Error fetching GP list:", error);
                    setGpDataList([]);
                });
        }
    };

    const onGp = (e) => {
        setGp(e.target.value);
        setReportFor("");
        setSchemeBalanceDetails([]);
    };

    const onFinYearChange = (e) => {
        setFinYear(e.target.value);
        setSchemeBalanceDetails([]);
    };

    const onReportFor = (e) => {
        setReportFor(e.target.value);
        setSchemeBalanceDetails([]);
    };

    const onSchemeChange = (e) => {
        setScheme(e.target.value);
        setSchemeBalanceDetails([]);
    };

    const onFromMonthChange = (e) => {
        const selectedMonth = e.target.value; // Example: 2026-05

        if (selectedMonth) {
            setFromDate(`${selectedMonth}-01`); // Always 1st day of selected month
        } else {
            setFromDate("");
        }

        setSchemeBalanceDetails([]);
    };

    const onSearch = () => {
        if (!district) {
            toast.error("Please select District");
            return;
        }

        if (!reportFor) {
            toast.error("Please select Report Type");
            return;
        }

        // if (!scheme) {
        //     toast.error("Please select Scheme");
        //     return;
        // }

        // if (!finYear) {
        //     toast.error("Please select Financial Year");
        //     return;
        // }

        if (!fromDate) {
            toast.error("Please select From Month");
            return;
        }

        if (!toDate) {
            toast.error("Please select To Date");
            return;
        }

        if (fromDate > toDate) {
            toast.error("From Date cannot be greater than To Date");
            return;
        }

        getPriWiseReceiptPayment(
            district ? district : 0,
            block ? block : 0,
            gp ? gp : 0,
            reportFor,
            fromDate,
            toDate
        )
            .then((response) => {
                if (response.status === 200) {
                    const responseData = response?.data || {};

                    if (responseData?.dtls && responseData?.dtls.length > 0) {
                        toast.success("Data Fetched Successfully");
                        setSchemeBalanceDetails(responseData);
                    } else {
                        toast.error("No data found");
                        setSchemeBalanceDetails({
                            schemeName: "",
                            dtls: [],
                        });
                    }
                } else {
                    toast.error("Failed to fetch data");
                    setSchemeBalanceDetails({
                        schemeName: "",
                        dtls: [],
                    });
                }
            })
            .catch((error) => {
                console.error("Search API error:", error);
                toast.error("Failed to fetch data");
                setSchemeBalanceDetails({
                    schemeName: "",
                    dtls: [],
                });
            });
    };

    const getNumericValue = (value) => {
        if (value === undefined || value === null || value === "") {
            return 0;
        }

        const numberValue = Number(String(value).replace(/,/g, ""));
        return Number.isNaN(numberValue) ? 0 : numberValue;
    };

    const splitPriForExcel = (priValue) => {
        const priText = String(priValue || "")
            .replace(/\u00A0/g, " ")
            .replace(/\s+/g, " ")
            .trim();

        if (priText.includes("::")) {
            const parts = priText.split("::");

            return {
                hasBlockGp: true,
                pri: "",
                block: parts[0]?.trim() || "",
                gp: parts.slice(1).join("::")?.trim() || "",
            };
        }

        return {
            hasBlockGp: false,
            pri: priText,
            block: "",
            gp: "",
        };
    };

    const exportToExcel = () => {
        const reportRows = Array.isArray(schemeBalanceDetails?.dtls)
            ? schemeBalanceDetails.dtls
            : [];

        if (reportRows.length === 0) {
            toast.error("No data available to download");
            return;
        }

        const excelRows = reportRows.map((item) => ({
            item,
            splitData: splitPriForExcel(item?.priName),
        }));

        const hasBlockGpData = excelRows.some(
            (row) => row.splitData.hasBlockGp
        );
        const hasPriData = excelRows.some(
            (row) => !row.splitData.hasBlockGp && row.splitData.pri
        );

        const worksheetData = excelRows.map((row, index) => {
            const { item, splitData } = row;
            const rowData = {
                "SL No.": index + 1,
            };

            if (hasPriData) {
                rowData.PRI = splitData.hasBlockGp ? "" : splitData.pri;
            }

            if (hasBlockGpData) {
                rowData.Block = splitData.hasBlockGp ? splitData.block : "";
                rowData.GP = splitData.hasBlockGp ? splitData.gp : "";
            }

            rowData["Opening Balance"] = getNumericValue(
                item?.openingBalance
            );
            rowData["Total Receipt"] = getNumericValue(item?.totalReceipt);
            rowData["Total Payment"] = getNumericValue(item?.totalPayment);
            rowData["Closing Balance"] = getNumericValue(
                item?.closingBalance
            );

            return rowData;
        });

        const grandTotalRow = {
            "SL No.": "",
        };

        if (hasPriData) {
            grandTotalRow.PRI = "Grand Total";
        }

        if (hasBlockGpData) {
            grandTotalRow.Block = hasPriData ? "" : "Grand Total";
            grandTotalRow.GP = "";
        }

        grandTotalRow["Opening Balance"] = reportRows.reduce(
            (sum, item) => sum + getNumericValue(item?.openingBalance),
            0
        );
        grandTotalRow["Total Receipt"] = reportRows.reduce(
            (sum, item) => sum + getNumericValue(item?.totalReceipt),
            0
        );
        grandTotalRow["Total Payment"] = reportRows.reduce(
            (sum, item) => sum + getNumericValue(item?.totalPayment),
            0
        );
        grandTotalRow["Closing Balance"] = reportRows.reduce(
            (sum, item) => sum + getNumericValue(item?.closingBalance),
            0
        );

        const finalWorksheetData = [...worksheetData, grandTotalRow];
        const worksheet = XLSX.utils.json_to_sheet(finalWorksheetData);

        const columnWidths = [{ wch: 8 }];

        if (hasPriData) {
            columnWidths.push({ wch: 40 });
        }

        if (hasBlockGpData) {
            columnWidths.push({ wch: 25 });
            columnWidths.push({ wch: 35 });
        }

        worksheet["!cols"] = [
            ...columnWidths,
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "PRI Wise Receipt Payment"
        );

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, "PRI_Wise_Receipt_Payment.xlsx");
    };

    let DistrictListDropDown = <option value="">Select District</option>;
    if (getDistrictDataList && getDistrictDataList.length > 0) {
        DistrictListDropDown = [
            <option value="" key="default-district">
                Select District
            </option>,
            ...getDistrictDataList.map((distRow, index) => (
                <option key={index} value={distRow.DIST_LGD}>
                    {distRow.DIST_NAME}
                </option>
            )),
        ];
    }

    let BlockListDropDown = <option value="">Select Block</option>;
    if (getBlockDataList && getBlockDataList.length > 0) {
        BlockListDropDown = [
            <option value="" key="default-block">
                Select Block
            </option>,
            ...getBlockDataList.map((blRow, index) => (
                <option key={index} value={blRow.BLOCK_LGD}>
                    {blRow.BLOCK_NAME}
                </option>
            )),
        ];
    }

    let GpListDropDown = <option value="">Select Gram Panchayat</option>;
    if (getGpDataList && getGpDataList.length > 0) {
        GpListDropDown = [
            <option value="" key="default-gp">
                Select Gram Panchayat
            </option>,
            ...getGpDataList.map((gpRow, index) => (
                <option key={index} value={gpRow.GP_LGD}>
                    {gpRow.GP_NAME}
                </option>
            )),
        ];
    }

    let FinYearDropDown = <option value="">Select Financial Year</option>;
    if (finYearList && finYearList.length > 0) {
        FinYearDropDown = [
            <option value="" key="default-finyear">
                Select Financial Year
            </option>,
            ...finYearList.map((item, index) => (
                <option key={index} value={item.finYear}>
                    {item.finYear}
                </option>
            )),
        ];
    }

    return (
        <div>
            <ToastContainer />
            <div
                className="bg-white rounded-lg p-2 flex flex-col flex-grow"
                style={{ marginTop: "-40px" }}
            >
                <legend className="text-lg font-semibold text-cyan-700">
                    PRI Wise Receipt Payment
                </legend>

                <div className="flex flex-col space-y-2 py-1">
                    <div className="flex flex-col w-full mb-4 space-y-2">
                        <div className="flex items-end flex-wrap">
                            <div className="w-1/4">
                                <label
                                    htmlFor="district"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    District <span className="text-red-500">*</span>
                                </label>
                                <select
                                    id="district"
                                    name="district"
                                    autoComplete="off"
                                    className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                                    value={district}
                                    onChange={onDistrict}
                                >
                                    {DistrictListDropDown}
                                </select>
                            </div>

                            <div className="w-1/4 px-2">
                                <label
                                    htmlFor="block"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    Block
                                </label>
                                <select
                                    id="block"
                                    name="block"
                                    autoComplete="off"
                                    className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                                    onChange={onBlock}
                                    value={block}
                                >
                                    {BlockListDropDown}
                                </select>
                            </div>

                            <div className="w-1/4 px-2">
                                <label
                                    htmlFor="gp"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    Gram Panchayat
                                </label>
                                <select
                                    id="gp"
                                    name="gp"
                                    autoComplete="off"
                                    className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                                    onChange={onGp}
                                    value={gp}
                                >
                                    {GpListDropDown}
                                </select>
                            </div>
                            {/* 
                            <div className="w-1/4 px-2">
                                <label
                                    htmlFor="financial_year"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    Financial Year <span className="text-red-500">*</span>
                                </label>
                                <select
                                    id="financial_year"
                                    name="financial_year"
                                    autoComplete="off"
                                    className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                                    value={finYear}
                                    onChange={onFinYearChange}
                                >
                                    {FinYearDropDown}
                                </select>
                            </div> */}

                            <div className="w-1/4 mt-2">
                                <label
                                    htmlFor="report_type"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    Report Type <span className="text-red-500">*</span>
                                </label>
                                <select
                                    id="report_type"
                                    name="report_type"
                                    autoComplete="off"
                                    className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                                    onChange={onReportFor}
                                    value={reportFor}
                                >
                                    <option value="">Select Report Type</option>
                                    <option value="1">ZP</option>
                                    <option value="2">PS</option>
                                    <option value="3">GP</option>
                                </select>
                            </div>


                            <div className="w-1/4 px-2 mt-2">
                                <label
                                    htmlFor="from_date"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    From Month <span className="text-red-500">*</span>
                                </label>
                                <input
                                    id="from_date"
                                    name="from_date"
                                    type="month"
                                    className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                                    value={fromDate ? fromDate.substring(0, 7) : ""}
                                    onChange={onFromMonthChange}
                                    max={toDate ? toDate.substring(0, 7) : getCurrentDate().substring(0, 7)}
                                />
                            </div>

                            <div className="w-1/4 px-2 mt-2">
                                <label
                                    htmlFor="to_date"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    To Date <span className="text-red-500">*</span>
                                </label>
                                <input
                                    id="to_date"
                                    name="to_date"
                                    type="date"
                                    className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                    min={fromDate || ""}
                                    max={getCurrentDate()}
                                />
                            </div>

                            <div className="w-1/2 mt-2 ml-auto">
                                <button
                                    type="button"
                                    className="btn-submit h-9 px-4 mt-5 shadow-sm text-white hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    onClick={onSearch}
                                >
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>

                    {!schemeBalanceDetails?.dtls ||
                        schemeBalanceDetails?.dtls?.length === 0 ? (
                        <div
                            className="flex items-center justify-center bg-gray-200"
                            style={{ marginTop: "10px" }}
                        >
                            <div className="text-center">
                                <h1 className="text-xl font-semibold text-black-800">
                                    No Data Found
                                </h1>
                            </div>
                        </div>
                    ) : (
                        <div className="overflow-x-auto p-4">
                            <div className="flex justify-between items-center mb-2">
                                <button
                                    onClick={exportToExcel}
                                    className="bg-green-600 text-white px-2 py-2 rounded hover:bg-green-700 transition"
                                >
                                    Download Excel
                                </button>

                                <h2 className="text-lg font-semibold text-gray-800 text-center animate-blink flex-1">
                                   PRI Wise Receipt Payment Report

                                </h2>
                            </div>

                            <div className="border rounded overflow-hidden">
                                <div className="max-h-[500px] overflow-y-auto">
                                    <table className="min-w-full divide-y divide-gray-200 border text-sm">
                                        <thead className="bg-cyan-600 text-white sticky top-0 z-10">
                                            <tr>
                                                <th className="px-4 py-2 text-left">SL No.</th>
                                                <th className="px-4 py-2 text-left">PRI Name</th>
                                                <th className="px-4 py-2 text-right">Opening Balance (₹)</th>
                                                <th className="px-4 py-2 text-right">Total Receipt (₹)</th>
                                                <th className="px-4 py-2 text-right">Total Payment (₹)</th>
                                                <th className="px-4 py-2 text-right">Closing Balance (₹)</th>
                                            </tr>
                                        </thead>

                                        <tbody className="divide-y divide-gray-100 bg-white">
                                            {schemeBalanceDetails?.dtls?.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="px-4 py-2">{index + 1}</td>
                                                    <td className="px-4 py-2">{item.priName}</td>

                                                    <td className="px-4 py-2 text-right">
                                                        {Number(item.openingBalance || 0).toLocaleString("en-IN", {
                                                            minimumFractionDigits: 2,
                                                        })}
                                                    </td>

                                                    <td className="px-4 py-2 text-right">
                                                        {Number(item.totalReceipt || 0).toLocaleString("en-IN", {
                                                            minimumFractionDigits: 2,
                                                        })}
                                                    </td>

                                                    <td className="px-4 py-2 text-right">
                                                        {Number(item.totalPayment || 0).toLocaleString("en-IN", {
                                                            minimumFractionDigits: 2,
                                                        })}
                                                    </td>

                                                    <td className="px-4 py-2 text-right font-semibold">
                                                        {Number(item.closingBalance || 0).toLocaleString("en-IN", {
                                                            minimumFractionDigits: 2,
                                                        })}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>

                                        <tfoot className="bg-gray-300 font-semibold text-black sticky bottom-0">
                                            <tr>
                                                <td className="px-4 py-2"></td>
                                                <td className="px-4 py-2 text-left">Grand Total</td>

                                                <td className="px-4 py-2 text-right">
                                                    {schemeBalanceDetails?.dtls
                                                        ?.reduce(
                                                            (sum, item) =>
                                                                sum + parseFloat(item.openingBalance || 0),
                                                            0
                                                        )
                                                        .toLocaleString("en-IN", {
                                                            minimumFractionDigits: 2,
                                                        })}
                                                </td>

                                                <td className="px-4 py-2 text-right">
                                                    {schemeBalanceDetails?.dtls
                                                        ?.reduce(
                                                            (sum, item) =>
                                                                sum + parseFloat(item.totalReceipt || 0),
                                                            0
                                                        )
                                                        .toLocaleString("en-IN", {
                                                            minimumFractionDigits: 2,
                                                        })}
                                                </td>

                                                <td className="px-4 py-2 text-right">
                                                    {schemeBalanceDetails?.dtls
                                                        ?.reduce(
                                                            (sum, item) =>
                                                                sum + parseFloat(item.totalPayment || 0),
                                                            0
                                                        )
                                                        .toLocaleString("en-IN", {
                                                            minimumFractionDigits: 2,
                                                        })}
                                                </td>

                                                <td className="px-4 py-2 text-right">
                                                    {schemeBalanceDetails?.dtls
                                                        ?.reduce(
                                                            (sum, item) =>
                                                                sum + parseFloat(item.closingBalance || 0),
                                                            0
                                                        )
                                                        .toLocaleString("en-IN", {
                                                            minimumFractionDigits: 2,
                                                        })}
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PriReceiptPayment;